import React, { useState, useEffect } from 'react';
import DocumentTable from './Components/DocumentTable';
import Login from './Components/Login';
import { fetchAllDocuments, searchDocuments, pivotDocuments } from './api';
import './App.css';
import Navbar from './Components/Navbar';
import LoadingOverlay from './Components/LoadingOverlay';
import Toast from './Components/Toast';

function App() {
  const [query, setQuery] = useState('');
  const [documents, setDocuments] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [company, setCompany] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const [logoPath, setLogoPath] = useState('');

  useEffect(() => {
    console.log("Version: 1.0.17");
  }, []);

  const showToast = (type, message) => {
    console.log("Type: ", type, " Message: ", message);
    setToast({type, message});
  }

  const closeToast = () => {
    setToast(null);
  }


  useEffect(() => {
    if (isLoggedIn) {
      fetchAndSetDocuments();
    }
  }, [isLoggedIn]);

  const fetchAndSetDocuments = async () => {
    try {
      const data = await fetchAllDocuments();
      setDocuments(data);
    } catch (error) {
      console.error('Error fetching documents:', error);
    }
  };

  const handleApply = async () => {
    try {
      setIsLoading(true);
      const data = await searchDocuments(query);
      setDocuments(data);
    } catch (error) {
      console.error('Error fetching documents:', error);
    }finally{
      setIsLoading(false);
    }
  };

  const handlePivot = async (doc) => {
    try {
      setIsLoading(true);
      const data = await pivotDocuments(doc);
      setDocuments(data);
    } catch (error) {
      console.error('Error fetching documents:', error);
    }finally{
      setIsLoading(false);
    }
  }

  const handleClear = () => {
    setQuery('');
    fetchAndSetDocuments();
  };

  const handleLoginSuccess = (company_name, logo_path) => {
    setCompany(company_name);
    setIsLoggedIn(true);
    setLogoPath(logo_path);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setCompany('');
    document.cookie = 'auth_token=; Max-Age=0; path=/;';
    setDocuments([]);
    setLogoPath('');
  }

  return (
    <div>
      {toast && (<Toast type={toast.type} message={toast.message} onClose={closeToast}/>
      )}
      <Navbar company={company} onLogout={handleLogout} logoPath={logoPath}/>
      <div className="main-container">
        <div className="content-container">
          {!isLoggedIn ? (
            <Login onLoginSuccess={handleLoginSuccess}/>
          ) : (
            <>
              {isLoading && <LoadingOverlay />}
              <h2>Known Good Answer Manager (kGAM)</h2>
              <div className="search-area">
                <input
                  type="text"
                  className="search-input"
                  value={query}
                  onChange={e => setQuery(e.target.value)}
                  placeholder="Search for similar questions or answers..."
                />
                {query && <button className="clear-button" onClick={handleClear}>&times;</button>}
                <button className="search-button" onClick={handleApply}>Apply</button>
              </div>
              <DocumentTable
                documents={documents}
                setDocuments={setDocuments}
                pivotHandler={handlePivot}
                fetchAndSetDocuments={fetchAndSetDocuments}
                setIsLoading={setIsLoading}
                showToast={showToast}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
